<template>
    <div :class="styleClass.formGroup">
        <label v-if="label"
            :for="id"
            class="form-control-label mr-1"
            v-text="label"></label>
        <label v-if="showOptionalLabel || (!disabled && optionalLabel)"
            :for="id"
            class="form-control-label text-muted mr-1"
            v-text="optionalLabel"></label>
        <div v-if="hasIcon" class="input-group-prepend">
            <div class="input-group-text">
                <i class="fa fa-user"></i>
            </div>
        </div>
        <template v-if="mask">
            <textarea v-if="type == 'textarea'"
                :id="id"
                :type="type"
                :name="name"
                :class="styleClass.input"
                :readonly="disabled"
                :value.sync="value"
                :placeholder="placeholder"
                autocomplete="off"
                ref="input"
                @input="input"
                @blur="blur"
                @focus="focus"
                v-mask="mask"
                :rows="rows"></textarea>
            <input v-else
                :id="id"
                :type="type"
                :name="name"
                :class="styleClass.input"
                :readonly="disabled"
                :value.sync="value"
                :placeholder="placeholder"
                autocomplete="off"
                ref="input"
                :accept="accept"
                @input="input"
                @blur="blur"
                @focus="focus"
                style="overflow:hidden"
                v-mask="mask" />
        </template>
        <template v-else>
            <textarea v-if="type == 'textarea'"
                :id="id"
                :type="type"
                :name="name"
                :class="styleClass.input"
                :readonly="disabled"
                :value.sync="value"
                :placeholder="placeholder"
                autocomplete="off"
                ref="input"
                @input="input"
                @blur="blur"
                @focus="focus"
                :rows="rows"></textarea>
            <input v-else-if="type == 'file'"
                :id="id"
                :type="type"
                :name="name"
                :class="styleClass.input"
                :readonly="disabled"
                :placeholder="placeholder"
                autocomplete="off"
                ref="input"
                :accept="accept"
                @change="input"
                @blur="blur"
                style="overflow:hidden"
                @focus="focus" />
            <input v-else
                :id="id"
                :type="type"
                :name="name"
                :class="styleClass.input"
                :readonly="disabled"
                :value.sync="value"
                :placeholder="placeholder"
                autocomplete="off"
                ref="input"
                @input="input"
                @blur="blur"
                @focus="focus" />
        </template>
        <span v-if="hasError" class="text-danger" v-text="errorMessage"></span>
    </div>
</template>
<script>
import { mask } from 'vue-the-mask';

export default {
    name: "FormInput",
    directives: { mask },
    props: {
        capitalize: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            default: false,
            type: Boolean,
        },
        label: String,
        accept: String,
        optionalLabel: String,
        name: String,
        placeholder: String,
        type: {
            default: 'text',
            type: String,
        },
        value: String | Number | Object | Array,
        alternative: {
            type: Boolean,
            default: false,
        },
        icon: String,
        mask: String|Array,
        rows: {
            default: 5,
            type: Number,
        },
        showOptionalLabel: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        id() {
            return `form-input-${ this._uid }`;
        },

        errorMessage() {
            return Array.isArray(this.error)
                ? this.error[0]
                : this.error;
        },

        hasError() {
            return this.error
                && (!this.isArrayAnEmptyString()
                || this.isArrayAnEmptyArray());
        },

        hasIcon() {
            return this.icon && this.icon.trim().length
        },
        
        styleClass() {
            return {
                formGroup: {
                    'form-group': true,
                    'input-group': this.hasIcon,
                    'has-danger': this.hasError,
                    'form-group-disabled': this.disabled,
                    'without-label': !this.label,
                },
                input: {
                    'form-control': true,
                    'form-control-alternative': this.alternative,
                    'is-invalid': this.hasError,
                    'text-capitalize': this.capitalize,
                },
            }
        },
    },
    data() {
        return {
            data: this.value,
            error: "",
        }
    },
    methods: {

        clearError() {
            this.error = null;
        },

        input(event) {
            if (this.hasError) {
                this.clearError();
            }
            if (this.type.toLowerCase() === "integer") {
                const value = parseInt(event.target.value);
                this.emmitInput(isNaN(value) ? 0 : value);
                return;
            } else if (this.type.toLowerCase() === "decimal" && event.target.value.split(".").length > 2) {
                this.emmitInput(parseFloat(event.target.value));
                return;
            } else if (this.type.toLowerCase() === "file") {
                console.log(event.target.files);
                console.log(!(event.target.files && event.target.files[0]));
                console.log(event.target.files[0]);
                if (!(event.target.files && event.target.files[0])) {
                    return this.emmitInput(null);
                }
                return this.emmitInput(event.target.files[0]);
            }
            this.emmitInput(event.target.value);
        },

        emmitInput(value) {
                if (this.type.toLowerCase() === "file") {
                    this.$emit("change", this.data = value);
                } else {
                    this.$emit("input", this.$refs.input.value = this.data = value);
                }
                this.$emit("fieldchanged", {
                    value: this.data,
                    field: this
                });
        },

        blur(event) {
            this.$emit("blur", event)
        },

        focus(event) {
            this.$emit("focus", event)
        },
        
        isArrayAnEmptyString() {
            return typeof this.error === "string"
                && !this.error.trim().length;
        },
        
        isArrayAnEmptyArray() {
            return Array.isArray(this.error)
                && !this.error.length;
        },

    }
}
</script>